<template>
  <div id="Login">
    <main>
      <img src="@/assets/img/avatar-logo.png">
      <VuiButton class="btn weixin" type="warning" size="large" round long @click.native="weixinLogin" v-if="!verifyCode">使用微信登录</VuiButton>
       <VuiButton class="btn weixin" type="warning" size="large" round long v-if="verifyCode" @click.native="weixinActiveLogin" >开通iCourt企业法律服务中台</VuiButton>
      <section id="weixin-qrcode"></section>
    </main>
  </div>
</template>

<script>
// import storage from '@/plugins/storage'
export default {
  name: 'Login',
  data () {
    return {
      verifyCode: this.$router.currentRoute.query.verifyCode,
    }
  },
  methods: {
    weixinLogin () {
      this.$store.dispatch('app/weixinLogin')
    },
    weixinActiveLogin () {
      this.$store.dispatch('app/weixinActiveLogin')
    },
  },
  watch: {
    $route (to, from) {
      this.verifyCode = this.$router.currentRoute.query.verifyCode
    },
  },
  mounted () {
    if (this.$router.currentRoute.query.verifyCode) {
      localStorage.setItem('verifyCode', this.$router.currentRoute.query.verifyCode)
    } else {
      localStorage.removeItem('verifyCode')
    }
  },
}
</script>

<style lang="scss" scoped>
#Login {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #f0f0f0;

  main {
    width: 360px;
    padding: 100px 60px;
    border-radius: 8px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    img {
      width: 128px;
      height: 128px;
    }

    .btn {
      padding: 12px;
      font-size: 14px;
      line-height: 20px;
      font-weight: normal;
    }

    .weixin {
      margin-top: 44px;
    }

    .passwd {
      margin-top: 24px;
      border-color: #f9f9f9;
      background-color: #f9f9f9;
      color: #868688;
    }
  }
}

#weixin-qrcode {
  /deep/ iframe {
    box-sizing: content-box;
    border-radius: 8px;
    background-color: #ffffff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 10px 30px;
  }
}
</style>
